import { render } from "./ConsultaSetupInfo.vue?vue&type=template&id=5e86e734&scoped=true"
import script from "./ConsultaSetupInfo.vue?vue&type=script&lang=js"
export * from "./ConsultaSetupInfo.vue?vue&type=script&lang=js"

import "./ConsultaSetupInfo.vue?vue&type=style&index=0&id=5e86e734&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e86e734"]])

export default __exports__